import React from 'react';
import styled from 'styled-components';

import { Button } from '../Button/Button';
import type { IconName } from '../Icon/Icon';

const Wrap = styled.div`
  margin-top: 14px;
`;

export type LoadMoreProps = {
  label: string;
  onClick: () => void;
  /** Leading glyph; defaults to the plus-in-circle used across the area. */
  icon?: IconName;
  /** Injected by styled-components when wrapped with styled(LoadMore). */
  className?: string;
};

/** Borderless ghost "load more" text button (48px tappable) with top spacing. */
export const LoadMore = ({ label, onClick, icon = 'plus-circle', className }: LoadMoreProps): React.ReactElement => (
  <Wrap className={className}>
    <Button label={label} variant="text" icon={icon} fullWidth onClick={onClick} />
  </Wrap>
);

export default LoadMore;
